
import React, { useState } from 'react';
import { Textarea } from '@/components/ui/textarea';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';
import { Card, CardContent } from '@/components/ui/card';
import ProductSummaryToggle from './ProductSummaryToggle';

interface ProductOverviewProps {
  overview: string;
  setOverview: (overview: string) => void;
  showSummary?: boolean;
  setShowSummary?: (show: boolean) => void;
}

const ProductOverview = ({ 
  overview, 
  setOverview, 
  showSummary: externalShowSummary, 
  setShowSummary: externalSetShowSummary 
}: ProductOverviewProps) => {
  // Local state if external state is not provided
  const [localShowSummary, setLocalShowSummary] = useState(true);
  
  // Use either external state (if provided) or local state
  const showSummary = externalSetShowSummary ? externalShowSummary : localShowSummary;
  const setShowSummary = externalSetShowSummary || setLocalShowSummary;

  return (
    <div className="dark:bg-[#1a1a2e] bg-white rounded-md shadow-sm border border-gray-200 dark:border-gray-800">
      <ProductSummaryToggle 
        showSummary={showSummary} 
        setShowSummary={setShowSummary} 
      />
      
      {showSummary && (
        <div className="p-6">
          <Label htmlFor="overview" className="text-gray-700 dark:text-gray-200 mb-2 block">Aperçu du produit</Label>
          <Textarea 
            id="overview" 
            value={overview} 
            onChange={(e) => setOverview(e.target.value)} 
            placeholder="Bref aperçu du produit"
            className="min-h-[100px] dark:bg-[#151521] dark:text-gray-200 dark:border-gray-700 dark:placeholder:text-gray-500"
          />
        </div>
      )}
    </div>
  );
};

export default ProductOverview;
